export default __webpack_public_path__ + "static/media/mixed.5bd16548.gif";